<div class="gutter">
<header #header class="flx-col flx-gap-default">
		<h1 #headerTitle *ngIf="pageTitle">{{ pageTitle }}</h1>
</header>


<div class="flx-row flx-wrap-grid flx-wrap-grid-2-xs flx-wrap-grid-3-sm flx-wrap-grid-3-md">
	<div *ngFor="let article of articles; let i = index" >
		<div class="article flx-col hoverable">
			<a class="article-img-wrap" [routerLink]="['/'+path_details, article.path]">
				<div class="badges">
					<span class="badge">{{ article.date_publish | date:'mediumDate' }}</span>
				</div>
				<app-image *ngIf="article.photos.length" [natural]="false" [url]="cdn+'/articles/'+article.photos_directory+'/medium_'+article.photos[0].filename"></app-image>
			</a>
			<a [routerLink]="['/'+path_details, article.path]" class="article-content flx-col flx-btwn-strtch">
				<h3>{{ article.name }}</h3>
				<p>{{ article.summary }}</p>
				<span><svg class="icon icon-arrow-narrow-right"><use xlink:href="#icon-arrow-narrow-right"></use></svg></span>
			</a>
		</div>		
	</div>
</div>

<mat-paginator #paginator
				[hidePageSize]="true"
				[length]="count"
				[pageIndex]="(query['page'] - 1)"
				[pageSize]="query['pageSize']"
				[pageSizeOptions]="[12, 24, 48]"
				(page)="onPage($event)">
</mat-paginator>

</div>
